import React, { useState } from 'react'
import { Box, TextField, Typography, ClickAwayListener } from '@mui/material'
import { useSurveyStore } from '../../surveyutilities/surveyStore'

function TextAreaBlock({ block, position }) {
  const [editingTitle, setEditingTitle] = useState(false);
  const [editingDescription, setEditingDescription] = useState(false);
  const updateQuestion = useSurveyStore((state) => state.updateQuestion);

  const handleTitleClick = () => {
    setEditingTitle(true);
  };

  const handleDescriptionClick = () => {
    setEditingDescription(true);
  };

  const handleTitleChange = (event) => {
    updateQuestion(block.internalId, { title: event.target.value });
  };

  const handleDescriptionChange = (event) => {
    updateQuestion(block.internalId, { description: event.target.value });
  };

  const handleClickAway = () => {
    setEditingTitle(false);
    setEditingDescription(false);
  };

  return (
      <Box>
        <ClickAwayListener onClickAway={handleClickAway}>
          <Box>
            {editingTitle ? (
                <TextField
                    autoFocus
                    fullWidth
                    value={block.title}
                    onChange={handleTitleChange}
                    onBlur={handleClickAway}
                    variant="outlined"
                    sx={{ mb: 1 }}
                />
            ) : (
                <Typography
                    sx={{ mb: 1, cursor: 'pointer', '&:hover': { backgroundColor: '#f5f5f5' } }}
                    onClick={handleTitleClick}
                >
                  {position + 1}. {block.title} {block.required ? <span style={{color: 'red'}}>*</span> : ''}
                </Typography>
            )}

            {editingDescription ? (
                <TextField
                    autoFocus
                    fullWidth
                    value={block.description}
                    onChange={handleDescriptionChange}
                    onBlur={handleClickAway}
                    variant="outlined"
                    multiline
                    maxRows={4}
                    sx={{ mb: 1 }}
                />
            ) : (
                <Typography
                    variant="body2"
                    sx={{ mb: 1, cursor: 'pointer', '&:hover': { backgroundColor: '#f5f5f5' } }}
                    onClick={handleDescriptionClick}
                >
                  {block.description}
                </Typography>
            )}

            <TextField
                fullWidth
                placeholder={block.placeholder}
                variant="outlined"
                size="small"
                disabled
                required={block.required}
                multiline
                rows={4}
                minRows={3}
                maxRows={8}
                sx={{
                  '& .MuiInputBase-root': {
                    resize: 'vertical', // Allow vertical resizing
                    minHeight: '80px' // Minimum height for textarea
                  }
                }}
            />

            {/* Character counter (optional feature) */}
            {block.maxLength && (
                <Typography variant="caption" color="textSecondary" sx={{ mt: 0.5, display: 'block' }}>
                  Maximum {block.maxLength} characters
                </Typography>
            )}
          </Box>
        </ClickAwayListener>
      </Box>
  )
}

export default TextAreaBlock